import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _17bd5b99 = () => interopDefault(import('../pages/theme-4/activities/index.vue' /* webpackChunkName: "pages/theme-4/activities/index" */))
const _123aa7ea = () => interopDefault(import('../pages/theme-4/cashier.vue' /* webpackChunkName: "pages/theme-4/cashier" */))
const _a73dba98 = () => interopDefault(import('../pages/theme-4/download/index.vue' /* webpackChunkName: "pages/theme-4/download/index" */))
const _0494e826 = () => interopDefault(import('../pages/theme-4/exchange-rewards/index.vue' /* webpackChunkName: "pages/theme-4/exchange-rewards/index" */))
const _61967f2c = () => interopDefault(import('../pages/theme-4/forgot-password.vue' /* webpackChunkName: "pages/theme-4/forgot-password" */))
const _d49f3daa = () => interopDefault(import('../pages/theme-4/games/index.vue' /* webpackChunkName: "pages/theme-4/games/index" */))
const _43b61824 = () => interopDefault(import('../pages/theme-4/leaderboard.vue' /* webpackChunkName: "pages/theme-4/leaderboard" */))
const _ba95bd60 = () => interopDefault(import('../pages/theme-4/login.vue' /* webpackChunkName: "pages/theme-4/login" */))
const _f4155bb2 = () => interopDefault(import('../pages/theme-4/my-bonus.vue' /* webpackChunkName: "pages/theme-4/my-bonus" */))
const _662e3328 = () => interopDefault(import('../pages/theme-4/no-support.vue' /* webpackChunkName: "pages/theme-4/no-support" */))
const _836c1222 = () => interopDefault(import('../pages/theme-4/not-found.vue' /* webpackChunkName: "pages/theme-4/not-found" */))
const _540953d6 = () => interopDefault(import('../pages/theme-4/payment-methods/index.vue' /* webpackChunkName: "pages/theme-4/payment-methods/index" */))
const _d1b4375c = () => interopDefault(import('../pages/theme-4/play-game.vue' /* webpackChunkName: "pages/theme-4/play-game" */))
const _64204de6 = () => interopDefault(import('../pages/theme-4/promotion/index.vue' /* webpackChunkName: "pages/theme-4/promotion/index" */))
const _3f9efa77 = () => interopDefault(import('../pages/theme-4/refer-friend/index.vue' /* webpackChunkName: "pages/theme-4/refer-friend/index" */))
const _32a0b58c = () => interopDefault(import('../pages/theme-4/register.vue' /* webpackChunkName: "pages/theme-4/register" */))
const _59605840 = () => interopDefault(import('../pages/theme-4/third-party-payment.vue' /* webpackChunkName: "pages/theme-4/third-party-payment" */))
const _3cbe2e73 = () => interopDefault(import('../pages/theme-4/activities/missions/index.vue' /* webpackChunkName: "pages/theme-4/activities/missions/index" */))
const _2160f9dc = () => interopDefault(import('../pages/theme-4/banners/pwa/index.vue' /* webpackChunkName: "pages/theme-4/banners/pwa/index" */))
const _3f652f51 = () => interopDefault(import('../pages/theme-4/download/android.vue' /* webpackChunkName: "pages/theme-4/download/android" */))
const _778f06ef = () => interopDefault(import('../pages/theme-4/download/ios.vue' /* webpackChunkName: "pages/theme-4/download/ios" */))
const _03df3f48 = () => interopDefault(import('../pages/theme-4/history/coin-history.vue' /* webpackChunkName: "pages/theme-4/history/coin-history" */))
const _0aa8a5f6 = () => interopDefault(import('../pages/theme-4/history/game.vue' /* webpackChunkName: "pages/theme-4/history/game" */))
const _573e7e16 = () => interopDefault(import('../pages/theme-4/history/promotion-history.vue' /* webpackChunkName: "pages/theme-4/history/promotion-history" */))
const _5180ce0c = () => interopDefault(import('../pages/theme-4/history/reward-history.vue' /* webpackChunkName: "pages/theme-4/history/reward-history" */))
const _786f48e6 = () => interopDefault(import('../pages/theme-4/history/transaction/index.vue' /* webpackChunkName: "pages/theme-4/history/transaction/index" */))
const _71d9ce2d = () => interopDefault(import('../pages/theme-4/player/deposits/index.vue' /* webpackChunkName: "pages/theme-4/player/deposits/index" */))
const _35171924 = () => interopDefault(import('../pages/theme-4/player/messages/index.vue' /* webpackChunkName: "pages/theme-4/player/messages/index" */))
const _7e672ab8 = () => interopDefault(import('../pages/theme-4/player/profile.vue' /* webpackChunkName: "pages/theme-4/player/profile" */))
const _362f6066 = () => interopDefault(import('../pages/theme-4/player/profile-detail/index.vue' /* webpackChunkName: "pages/theme-4/player/profile-detail/index" */))
const _8deb8ed0 = () => interopDefault(import('../pages/theme-4/player/vip.vue' /* webpackChunkName: "pages/theme-4/player/vip" */))
const _940161c8 = () => interopDefault(import('../pages/theme-4/player/withdrawals/index.vue' /* webpackChunkName: "pages/theme-4/player/withdrawals/index" */))
const _4de5038e = () => interopDefault(import('../pages/theme-4/index.vue' /* webpackChunkName: "pages/theme-4/index" */))
const _44e1dd35 = () => interopDefault(import('../pages/theme-4/history/transaction/_id.vue' /* webpackChunkName: "pages/theme-4/history/transaction/_id" */))
const _1dc7bd18 = () => interopDefault(import('../pages/theme-4/pixel/_id.vue' /* webpackChunkName: "pages/theme-4/pixel/_id" */))
const _346a8a96 = () => interopDefault(import('../pages/theme-4/promotion/_id.vue' /* webpackChunkName: "pages/theme-4/promotion/_id" */))
const _4050c166 = () => interopDefault(import('../pages/theme-4/articles/_title/_slug.vue' /* webpackChunkName: "pages/theme-4/articles/_title/_slug" */))
const _bc3820aa = () => interopDefault(import('../pages/theme-4/_type/_id.vue' /* webpackChunkName: "pages/theme-4/_type/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/activities",
    component: _17bd5b99,
    name: "activities"
  }, {
    path: "/cashier",
    component: _123aa7ea,
    name: "cashier"
  }, {
    path: "/download",
    component: _a73dba98,
    name: "download"
  }, {
    path: "/exchange-rewards",
    component: _0494e826,
    name: "exchange-rewards"
  }, {
    path: "/forgot-password",
    component: _61967f2c,
    name: "forgot-password"
  }, {
    path: "/games",
    component: _d49f3daa,
    name: "games"
  }, {
    path: "/leaderboard",
    component: _43b61824,
    name: "leaderboard"
  }, {
    path: "/login",
    component: _ba95bd60,
    name: "login"
  }, {
    path: "/my-bonus",
    component: _f4155bb2,
    name: "my-bonus"
  }, {
    path: "/no-support",
    component: _662e3328,
    name: "no-support"
  }, {
    path: "/not-found",
    component: _836c1222,
    name: "not-found"
  }, {
    path: "/payment-methods",
    component: _540953d6,
    name: "payment-methods"
  }, {
    path: "/play-game",
    component: _d1b4375c,
    name: "play-game"
  }, {
    path: "/promotion",
    component: _64204de6,
    name: "promotion"
  }, {
    path: "/refer-friend",
    component: _3f9efa77,
    name: "refer-friend"
  }, {
    path: "/register",
    component: _32a0b58c,
    name: "register"
  }, {
    path: "/third-party-payment",
    component: _59605840,
    name: "third-party-payment"
  }, {
    path: "/activities/missions",
    component: _3cbe2e73,
    name: "activities-missions"
  }, {
    path: "/banners/pwa",
    component: _2160f9dc,
    name: "banners-pwa"
  }, {
    path: "/download/android",
    component: _3f652f51,
    name: "download-android"
  }, {
    path: "/download/ios",
    component: _778f06ef,
    name: "download-ios"
  }, {
    path: "/history/coin-history",
    component: _03df3f48,
    name: "history-coin-history"
  }, {
    path: "/history/game",
    component: _0aa8a5f6,
    name: "history-game"
  }, {
    path: "/history/promotion-history",
    component: _573e7e16,
    name: "history-promotion-history"
  }, {
    path: "/history/reward-history",
    component: _5180ce0c,
    name: "history-reward-history"
  }, {
    path: "/history/transaction",
    component: _786f48e6,
    name: "history-transaction"
  }, {
    path: "/player/deposits",
    component: _71d9ce2d,
    name: "player-deposits"
  }, {
    path: "/player/messages",
    component: _35171924,
    name: "player-messages"
  }, {
    path: "/player/profile",
    component: _7e672ab8,
    name: "player-profile"
  }, {
    path: "/player/profile-detail",
    component: _362f6066,
    name: "player-profile-detail"
  }, {
    path: "/player/vip",
    component: _8deb8ed0,
    name: "player-vip"
  }, {
    path: "/player/withdrawals",
    component: _940161c8,
    name: "player-withdrawals"
  }, {
    path: "/",
    component: _4de5038e,
    name: "index"
  }, {
    path: "/history/transaction/:id",
    component: _44e1dd35,
    name: "history-transaction-id"
  }, {
    path: "/pixel/:id?",
    component: _1dc7bd18,
    name: "pixel-id"
  }, {
    path: "/promotion/:id",
    component: _346a8a96,
    name: "promotion-id"
  }, {
    path: "/articles/:title?/:slug?",
    component: _4050c166,
    name: "articles-title-slug"
  }, {
    path: "/:type/:id?",
    component: _bc3820aa,
    name: "type-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
